import React from 'react';
import styled from '@emotion/styled';

export const ProjectsList = ({ children }) => <List>{children}</List>;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
